import { Plugins } from '@leverege/plugin';
import GroupedTextFilterFieldModel from "./GroupedTextFilterFieldModel.js";
import GroupedTextFilterModel from "./GroupedTextFilterModel.js";
const install = molten => {
  Plugins.add('GroupedTextFilterFieldFilter', {
    type: 'int',
    toFilter: attr => {
      // need to be careful with fieldType
      return {
        type: 'equalsIfFieldType',
        fieldType: 'number',
        field: attr?.blueprint?.field
      };
    }
  });
  Plugins.add('GroupedTextFilterFieldFilter', {
    type: 'string',
    toFilter: attr => {
      // need to be careful with fieldType
      return {
        type: 'interfixFinalToken',
        // this is implied now
        // filter : { type : 'expression', ignoreCase : true, kind : 'queryString', analyzeWildcard : true },
        field: attr?.blueprint?.field
      };
    }
  });
  Plugins.add('GroupedTextFilterFieldFilter', {
    type: 'enum',
    toFilter: attr => {
      // need to be careful with fieldType
      return {
        type: 'interfixFinalToken',
        // this is implied now
        // filter : { type : 'expression', ignoreCase : true, kind : 'queryString', analyzeWildcard : true },
        field: attr?.blueprint?.field
      };
    }
  });
  Plugins.add('Model', {
    type: GroupedTextFilterModel.TYPE,
    model: GroupedTextFilterModel
  });
  Plugins.add('Model', {
    type: GroupedTextFilterFieldModel.TYPE,
    model: GroupedTextFilterFieldModel
  });
};
export default {
  install
};